import React, { useState } from "react";
import styled from "styled-components";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import winedancersImage from "./Images/WineDancers.png";
import "./App.css";

const RSVPContainer = styled.div`
  width: 100vw;
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  padding: 0 1rem;
  background-color: #f5e9dd;
`;

const RSVPWrapper = styled.div`
  background-color: rgb(255, 246, 237);
  backdrop-filter: blur(5px);
  border-radius: 10px;
  border: 1px solid #1b3619;
  border-image: url("data:image/svg+xml,%3csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3e%3cfilter id='noiseFilter'%3e%3cfeTurbulence type='fractalNoise' baseFrequency='1.2' numOctaves='4' stitchTiles='stitch'/%3e%3c/filter%3e%3crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.4'/%3e%3c/svg%3e")
    1;
  border-style: solid;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;

const TitleImage = styled.img`
  max-width: 150px;
  height: auto;
  margin-bottom: 1rem;
  flex-shrink: 0;
`;

const RSVPTitle = styled.h1`
  font-family: "Monsieur La Doulaise", cursive;
  font-size: 6vmin;
  text-align: center;
  margin-bottom: 1rem;
  margin-top: 0;
  flex-shrink: 0;
`;

const RSVPSubtitle = styled.p`
  font-family: "IM Fell English", serif;
  font-size: 0.9rem;
  margin-bottom: 2rem;
  line-height: 1.4;
`;

const FormContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  flex: 1;
`;

const FormSection = styled.div`
  margin-bottom: 2rem;
  text-align: left;
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-family: "IM Fell English", serif;
  font-size: 0.9rem;
  margin-bottom: 0.4rem;
  font-weight: 400;
`;

const Input = styled.input`
  font-family: "IM Fell English", serif;
  font-size: 0.9rem;
  padding: 0.6rem 0.85rem;
  border: 1px solid rgba(139, 121, 94, 0.3);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);

  &:focus {
    outline: none;
    border-color: #333;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 0 0 2px rgba(27, 54, 25, 0.1),
      0 3px 8px rgba(139, 121, 94, 0.15);
    transform: translateY(-1px);
  }

  &:hover:not(:focus) {
    border-color: rgba(139, 121, 94, 0.5);
    background: rgba(255, 255, 255, 0.9);
  }

  &::placeholder {
    color: rgba(27, 54, 25, 0.5);
    font-style: italic;
    font-size: 0.8rem;
  }
`;

const TextArea = styled.textarea`
  font-family: "IM Fell English", serif;
  font-size: 0.9rem;
  padding: 0.6rem 0.85rem;
  border: 1px solid rgba(139, 121, 94, 0.3);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.8);
  resize: vertical;
  min-height: 80px;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  line-height: 1.4;

  &:focus {
    outline: none;
    border-color: #333;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 0 0 2px rgba(27, 54, 25, 0.1),
      0 3px 8px rgba(139, 121, 94, 0.15);
    transform: translateY(-1px);
  }

  &:hover:not(:focus) {
    border-color: rgba(139, 121, 94, 0.5);
    background: rgba(255, 255, 255, 0.9);
  }

  &::placeholder {
    color: rgba(27, 54, 25, 0.5);
    font-style: italic;
    font-size: 0.8rem;
  }
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.5rem;
`;

const RadioOption = styled.label`
  display: flex;
  align-items: center;
  font-family: "IM Fell English", serif;
  font-size: 0.9rem;
  cursor: pointer;

  input {
    margin-right: 0.75rem;
    transform: scale(1.2);
    accent-color: #333;
  }
`;

const SubmitButton = styled.button`
  background-color: transparent;
  border: 1px solid #333;
  transition: all 0.3s ease-in-out;
  font-family: "Monsieur La Doulaise", cursive;
  font-weight: 400;
  font-style: normal;
  font-size: 1.1rem;
  text-align: center;
  padding: 0.75rem 2rem;
  color: #333;
  cursor: pointer;
  border-radius: 6px;
  max-width: 350px;
  margin: 2rem auto 0;
  display: block;
  letter-spacing: 0.3px;
  position: relative;
  overflow: hidden;

  &:hover:not(:disabled) {
    background-color: #333;
    color: #fef6ec;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(51, 51, 51, 0.2);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  padding: 2rem;

  h2 {
    font-family: "Monsieur La Doulaise", cursive;
    font-size: 4rem;
    margin-bottom: 1rem;
  }

  p {
    font-family: "IM Fell English", serif;
    font-size: 1.2rem;
    line-height: 1.6;
  }
`;

const RSVP = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    attendance: "",
    dietaryRequirements: "",
    specialMessage: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await addDoc(collection(db, "formal-rsvps"), {
        ...formData,
        timestamp: serverTimestamp(),
        submittedAt: new Date().toISOString(),
      });
      setIsSubmitted(true);
    } catch (error) {
      console.error("Error submitting RSVP:", error);
      alert(
        "Sorry, there was an error submitting your RSVP. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <RSVPContainer>
        <RSVPWrapper>
          <SuccessMessage>
            <h2>Thank You!</h2>
            <p>
              Your RSVP has been received. We are so grateful for your response
              and cannot wait to celebrate with you!
            </p>
          </SuccessMessage>
        </RSVPWrapper>
      </RSVPContainer>
    );
  }

  return (
    <RSVPContainer>
      <RSVPWrapper>
        <TitleImage
          src={winedancersImage}
          alt="Wine Dancers"
          loaded={imageLoaded}
          onLoad={() => setImageLoaded(true)}
        />
        <RSVPTitle>Kindly Respond</RSVPTitle>
        <RSVPSubtitle>
          We request the pleasure of your reply.
          <p>Please respond by 1st May 2026.</p>
        </RSVPSubtitle>

        <FormContainer>
          <form onSubmit={handleSubmit}>
            <FormSection>
              <FormRow>
                <FormField>
                  <Label htmlFor="name">Full Name *</Label>
                  <Input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </FormField>
                <FormField>
                  <Label htmlFor="email">Email Address *</Label>
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </FormField>
              </FormRow>

              <FormField>
                <Label htmlFor="phone">Phone Number</Label>
                <Input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
              </FormField>
            </FormSection>

            <FormSection>
              <Label>Will you be joining us? *</Label>
              <RadioGroup>
                <RadioOption>
                  <input
                    type="radio"
                    name="attendance"
                    value="accepts"
                    checked={formData.attendance === "accepts"}
                    onChange={handleInputChange}
                    required
                  />
                  Joyfully accepts
                </RadioOption>
                <RadioOption>
                  <input
                    type="radio"
                    name="attendance"
                    value="declines"
                    checked={formData.attendance === "declines"}
                    onChange={handleInputChange}
                    required
                  />
                  Regretfully declines
                </RadioOption>
              </RadioGroup>
            </FormSection>

            {formData.attendance === "accepts" && (
              <FormSection>
                <FormField>
                  <Label htmlFor="dietaryRequirements">
                    Dietary Requirements or Allergies
                  </Label>
                  <TextArea
                    id="dietaryRequirements"
                    name="dietaryRequirements"
                    value={formData.dietaryRequirements}
                    onChange={handleInputChange}
                    placeholder="Please let us know of any dietary needs..."
                  />
                </FormField>
              </FormSection>
            )}

            <FormSection>
              <FormField>
                <Label htmlFor="specialMessage">
                  A Note for the Happy Couple
                </Label>
                <TextArea
                  id="specialMessage"
                  name="specialMessage"
                  value={formData.specialMessage}
                  onChange={handleInputChange}
                  placeholder="We would love to hear from you..."
                />
              </FormField>
            </FormSection>

            <SubmitButton type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Send Reply"}
            </SubmitButton>
          </form>
        </FormContainer>
      </RSVPWrapper>
    </RSVPContainer>
  );
};

export default RSVP;
